/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import React from 'react';
import Icon from '../Icon.js';
import { i as iconPropTypes } from '../iconPropTypes-4cbeb95d.js';
import '@carbon/icon-helpers';
import 'prop-types';

var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _circle, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _circle2, _path90, _path91, _path92, _path93, _path94, _circle3, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _circle4, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _circle5, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _circle6, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _circle7, _path180, _path181, _path182, _circle8, _circle9, _path183, _circle10, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208;
const didWarnAboutDeprecation = {};
const TrashCan = /*#__PURE__*/React.forwardRef(function TrashCan(_ref, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12H14V24H12zM18 12H20V24H18z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6V8H6V28a2 2 0 002 2H24a2 2 0 002-2V8h2V6zM8 28V8H24V28zM12 2H20V4H12z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TrashCan.propTypes = iconPropTypes;
}
const Tree = /*#__PURE__*/React.forwardRef(function Tree(_ref2, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref2;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12,30H9V28h3V15.5664L8.4854,13.4575l1.0292-1.7148,3.5147,2.1084A2.0115,2.0115,0,0,1,14,15.5664V28A2.0023,2.0023,0,0,1,12,30Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22,30H19a2.0024,2.0024,0,0,1-2-2V17h6a4.0008,4.0008,0,0,0,3.981-4.396A4.1489,4.1489,0,0,0,22.7853,9H21.2016L21.025,8.221C20.452,5.6961,18.0308,4,15,4A6.02,6.02,0,0,0,9.5585,7.4859L9.25,8.1531l-.863-.1143A2.771,2.771,0,0,0,8,8a4,4,0,1,0,0,8v2A6,6,0,1,1,8,6c.0264,0,.0525,0,.0786.001A8.0271,8.0271,0,0,1,15,2c3.6788,0,6.6923,1.9776,7.7516,5h.0337a6.1641,6.1641,0,0,1,6.1872,5.4141A6.0011,6.0011,0,0,1,23,19l-4,0v9h3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Tree.propTypes = iconPropTypes;
}
const TreeFallRisk = /*#__PURE__*/React.forwardRef(function TreeFallRisk(_ref3, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref3;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z",
    "data-icon-path": "inner-path"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9115 13.9355L23.6284 2.3706a.7181.7181 0 00-1.2568 0L16.0885 13.9355A.72.72 0 0016.72 15H29.28A.72.72 0 0029.9115 13.9355zM22.25 6h1.5v4h-1.5zM23 13a1 1 0 111-1A1 1 0 0123 13zM26 19V17H17V28a2.0027 2.0027 0 002 2h3V28H19V19zM12 30H9V28h3V15.5664L8.4854 13.4575l1.0292-1.7148 3.5147 2.1084A2.0115 2.0115 0 0114 15.5664V28A2.0024 2.0024 0 0112 30z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6638,5.0059l.96-1.7671A8.9324,8.9324,0,0,0,15,2,8.0275,8.0275,0,0,0,8.0786,6.001C8.0525,6,8.0264,6,8,6A6,6,0,0,0,8,18V16A4,4,0,0,1,8,8a2.7009,2.7009,0,0,1,.387.0391l.863.1142.3086-.6675A6.0192,6.0192,0,0,1,15,4,6.8916,6.8916,0,0,1,18.6638,5.0059Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TreeFallRisk.propTypes = iconPropTypes;
}
const TreeView = /*#__PURE__*/React.forwardRef(function TreeView(_ref4, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref4;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30,20V12H22v3H17V7a2,2,0,0,0-2-2H10V2H2v8h8V7h5V25a2,2,0,0,0,2,2h5v3h8V22H22v3H17V17h5v3ZM8,8H4V4H8ZM24,24h4v4H24Zm0-10h4v4H24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TreeView.propTypes = iconPropTypes;
}
const TreeViewAlt = /*#__PURE__*/React.forwardRef(function TreeViewAlt(_ref5, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref5;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23,9h6a2,2,0,0,0,2-2V3a2,2,0,0,0-2-2H23a2,2,0,0,0-2,2V4H11V3A2,2,0,0,0,9,1H3A2,2,0,0,0,1,3V7A2,2,0,0,0,3,9H9a2,2,0,0,0,2-2V6h4V26a2.0023,2.0023,0,0,0,2,2h4v1a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V25a2,2,0,0,0-2-2H23a2,2,0,0,0-2,2v1H17V17h4v1a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V14a2,2,0,0,0-2-2H23a2,2,0,0,0-2,2v1H17V6h4V7A2,2,0,0,0,23,9Zm0-6h6V7H23ZM9,7H3V3H9ZM23,25h6v4H23Zm0-11h6v4H23Z",
    transform: "translate(0 .005)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TreeViewAlt.propTypes = iconPropTypes;
}
const Trophy = /*#__PURE__*/React.forwardRef(function Trophy(_ref6, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref6;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26,7H24V6a2.0023,2.0023,0,0,0-2-2H10A2.0023,2.0023,0,0,0,8,6V7H6A2.0023,2.0023,0,0,0,4,9v3a4.0045,4.0045,0,0,0,4,4h.322A8.1689,8.1689,0,0,0,15,21.9341V26H10v2H22V26H17V21.9311A7.9661,7.9661,0,0,0,23.74,16H24a4.0045,4.0045,0,0,0,4-4V9A2.0023,2.0023,0,0,0,26,7ZM8,14a2.0023,2.0023,0,0,1-2-2V9H8Zm14,0a6,6,0,0,1-6.1855,5.9971A6.1991,6.1991,0,0,1,10,13.7065V6H22Zm4-2a2.0023,2.0023,0,0,1-2,2V9h2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Trophy.propTypes = iconPropTypes;
}
const TrophyFilled = /*#__PURE__*/React.forwardRef(function TrophyFilled(_ref7, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref7;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26,7H24V6a2.0023,2.0023,0,0,0-2-2H10A2.0023,2.0023,0,0,0,8,6V7H6A2.0023,2.0023,0,0,0,4,9v3a4.0045,4.0045,0,0,0,4,4h.322A8.1689,8.1689,0,0,0,15,21.9341V26H10v2H22V26H17V21.9311A7.9661,7.9661,0,0,0,23.74,16H24a4.0045,4.0045,0,0,0,4-4V9A2.0023,2.0023,0,0,0,26,7ZM8,14a2.0023,2.0023,0,0,1-2-2V9H8Zm18-2a2.0023,2.0023,0,0,1-2,2V9h2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TrophyFilled.propTypes = iconPropTypes;
}
const TropicalStorm = /*#__PURE__*/React.forwardRef(function TropicalStorm(_ref8, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref8;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16,21a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,16,21Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,16,13Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6521,4.1821l-2.177,2.5142L19.0713,8.3174,20.7864,9.605A7.9361,7.9361,0,0,1,23.9963,16l.0008.0576.0017.0415c.018.4317.2412,10.1113-14.6538,11.7222l2.18-2.5176,1.4039-1.6211L11.2139,22.395A7.9361,7.9361,0,0,1,8.0037,16l-.0008-.0576-.0017-.0415C7.9832,15.47,7.7605,5.8071,22.6521,4.1821M24.9978,2c-.0164,0-.0327,0-.0493.001C5.2532,2.9146,6.0037,16,6.0037,16a9.975,9.975,0,0,0,4.0095,7.9946L6.2368,28.3555A1.0044,1.0044,0,0,0,7.0022,30c.0164,0,.0327,0,.0493-.001C26.7468,29.0854,25.9963,16,25.9963,16a9.9756,9.9756,0,0,0-4.0092-7.9946l3.7761-4.3609A1.0044,1.0044,0,0,0,24.9978,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TropicalStorm.propTypes = iconPropTypes;
}
const TropicalStormModelTracks = /*#__PURE__*/React.forwardRef(function TropicalStormModelTracks(_ref9, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref9;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10,17a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,10,17Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,10,11Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8188 6.65c.1163-.1211 1.8643-1.919 2.8882-2.9434A1 1 0 0017 2C11.812 2 2 4.2988 2 13a7.8938 7.8938 0 003.1812 6.35c-.1612.1675-1.9507 2.0054-2.8882 2.9429A1 1 0 003 24c5.188 0 15-2.2988 15-11A7.8927 7.8927 0 0014.8188 6.65zM9.7065 20.793a20.94 20.94 0 01-4.0932.9853c.1621-.166 2.7685-2.9053 2.7685-2.9053l-1.1743-.6074A5.9064 5.9064 0 014 13c0-3.667 2.1177-6.2886 6.2935-7.793a20.94 20.94 0 014.0932-.9853c-.227.2324-2.769 2.9057-2.769 2.9057l1.1748.607A5.9075 5.9075 0 0116 13C16 16.667 13.8823 19.2886 9.7065 20.793zM30 17l-5-5-5 5 1.4126 1.4155L24 15.8325V19a9.01 9.01 0 01-9 9H12v2h3A11.0125 11.0125 0 0026 19V15.8325l2.5859 2.5816z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TropicalStormModelTracks.propTypes = iconPropTypes;
}
const TropicalStormTracks = /*#__PURE__*/React.forwardRef(function TropicalStormTracks(_ref10, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref10;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16,21a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,16,21Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,16,13Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26.86,12.4805h0a12.9277,12.9277,0,0,0-4.8575-4.9991q.2044-.213.4424-.4589h0c.82-.8482,1.93-1.9825,3.2622-3.3155A1,1,0,0,0,25,2c-.354,0-8.7363.0488-14.269,4.3018h0A12.15,12.15,0,0,0,7.481,9.998c-.1416-.1367-.295-.2841-.4585-.4423C6.1743,8.7349,5.04,7.6255,3.707,6.293A1,1,0,0,0,2,7c0,.3594.05,8.874,4.4058,14.4023a12.1023,12.1023,0,0,0,3.5918,3.1163c-.21.2177-.4346.4516-.6563.68h0c-.7954.8208-1.8286,1.8745-3.0483,3.0943A1,1,0,0,0,7,30c.2856,0,7.061-.0352,12.459-3.1055a12.9618,12.9618,0,0,0,5.06-4.8925q.3062.2937.68.6567c.82.7954,1.8745,1.8286,3.0943,3.0483A1,1,0,0,0,30,25C30,24.7119,29.9644,17.8877,26.86,12.4805Zm-3.03,6.1074-.5469,1.3672A10.5415,10.5415,0,0,1,18.47,25.1562,24.3514,24.3514,0,0,1,9.584,27.8135c.4409-.4492,3.8281-3.9824,3.8281-3.9824l-1.3682-.5474a9.8021,9.8021,0,0,1-4.0668-3.1191c-2.5406-3.2242-3.4585-7.7623-3.79-10.58.5435.5337,3.9815,3.8266,3.9815,3.8266l.5468-1.3672A9.8569,9.8569,0,0,1,11.95,7.8877h0C15.1665,5.415,19.6309,4.5146,22.4155,4.187c-.5332.5435-3.8276,3.9819-3.8276,3.9819l1.3677.5469a10.52,10.52,0,0,1,5.17,4.7608v0a24.29,24.29,0,0,1,2.688,8.94C27.3643,21.9751,23.83,18.5879,23.83,18.5879Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TropicalStormTracks.propTypes = iconPropTypes;
}
const TropicalWarning = /*#__PURE__*/React.forwardRef(function TropicalWarning(_ref11, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref11;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9487,25.6836a1,1,0,0,0-1.8955-.0049A3.44,3.44,0,0,1,23,28a3.44,3.44,0,0,1-3.0532-2.3213,1,1,0,0,0-1.8955.0049A3.4376,3.4376,0,0,1,15,28h-.4336C13.9241,26.7939,12,22.312,12,12v-.1313l1.1169.7446A6.46,6.46,0,0,1,14.4346,13.79l1.0007-1.8418a8.4469,8.4469,0,0,0-1.209-.9986L12.8025,10h1.5308a6.9861,6.9861,0,0,1,1.9934.3071l.9755-1.7954A9.0059,9.0059,0,0,0,14.3333,8H13.1169A7.0329,7.0329,0,0,1,18,6h.6669l1.0867-2H18a9.0361,9.0361,0,0,0-7,3.3638A9.0362,9.0362,0,0,0,4,4H2V6H4A7.0308,7.0308,0,0,1,8.8828,8H7.6665a9.06,9.06,0,0,0-5.4,1.8L.4,11.2l1.2,1.6L3.4668,11.4a7.04,7.04,0,0,1,4.2-1.4H9.1973l-1.4239.9492A8.457,8.457,0,0,0,4,18H6a6.46,6.46,0,0,1,2.8828-5.3867L10,11.8687V12c0,8.9365,1.3994,13.7539,2.355,16H2v2H15a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0,4.9955,4.9955,0,0,0,3,1.8833V27.8125A3.7616,3.7616,0,0,1,27.9487,25.6836Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TropicalWarning.propTypes = iconPropTypes;
}
const Tsq = /*#__PURE__*/React.forwardRef(function Tsq(_ref12, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref12;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M19 26H30V28H19zM19 22H30V24H19zM30 20h-11V12h11v8zm-9-2h7v-4h-7v4zM19 8H30V10H19zM19 4H30V6H19zM10.293 18.707L8 16.4143 8 12 10 12 10 15.5857 11.707 17.293 10.293 18.707z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M9,24c-4.4111,0-8-3.5889-8-8s3.5889-8,8-8,8,3.5889,8,8-3.5889,8-8,8Zm0-14c-3.3083,0-6,2.6917-6,6s2.6917,6,6,6,6-2.6917,6-6-2.6917-6-6-6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Tsq.propTypes = iconPropTypes;
}
const Tsunami = /*#__PURE__*/React.forwardRef(function Tsunami(_ref13, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref13;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M30,26H24A10.0349,10.0349,0,0,1,17.0732,8.7378,11.9629,11.9629,0,0,0,12.9937,8a6.9027,6.9027,0,0,0-6.0308,3.42C4.9966,14.4348,4,19.34,4,26H2c0-7.0542,1.106-12.3274,3.2871-15.6726A8.906,8.906,0,0,1,12.9937,6h.0068a14.762,14.762,0,0,1,6.4619,1.592,1,1,0,0,1,.0869,1.7222A8.0249,8.0249,0,0,0,24,24h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Tsunami.propTypes = iconPropTypes;
}
const Tsv = /*#__PURE__*/React.forwardRef(function Tsv(_ref14, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref14;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M28 9L26 22 24 9 22 9 24.516 23 27.484 23 30 9 28 9zM18 23H12V21h6V17H14a2.002 2.002 0 01-2-2V11a2.002 2.002 0 012-2h6v2H14v4h4a2.002 2.002 0 012 2v4A2.002 2.002 0 0118 23zM2 11L5 11 5 23 7 23 7 11 10 11 10 9 2 9 2 11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Tsv.propTypes = iconPropTypes;
}
const Tuning = /*#__PURE__*/React.forwardRef(function Tuning(_ref15, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref15;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M24 30v-4.1c2.3-.5 4-2.5 4-4.9 0-2.4-1.7-4.4-4-4.9V2s-2 0-2 0v14.1c-2.3.5-4 2.5-4 4.9 0 2.4 1.7 4.4 4 4.9v4.1s2 0 2 0zm-4-9c0-1.7 1.3-3 3-3s3 1.3 3 3c0 1.7-1.3 3-3 3s-3-1.3-3-3zM8 2v4.1c-2.3.5-4 2.5-4 4.9 0 2.4 1.7 4.4 4 4.9v14.1s2 0 2 0v-14.1c2.3-.5 4-2.5 4-4.9 0-2.4-1.7-4.4-4-4.9V2s-2 0-2 0zm4 9c0 1.7-1.3 3-3 3s-3-1.3-3-3 1.3-3 3-3 3 1.3 3 3z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Tuning.propTypes = iconPropTypes;
}
const TwoFactorAuthentication = /*#__PURE__*/React.forwardRef(function TwoFactorAuthentication(_ref16, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref16;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M11 23.18L9 21.179 7.589 22.589 11 26 17 20 15.59 18.59 11 23.18zM28 30H24V28h4V16H24V8a4.0045 4.0045 0 00-4-4V2a6.0067 6.0067 0 016 6v6h2a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M20,14H18V8A6,6,0,0,0,6,8v6H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16A2,2,0,0,0,20,14ZM8,8a4,4,0,0,1,8,0v6H8ZM20,28H4V16H20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TwoFactorAuthentication.propTypes = iconPropTypes;
}
const TwoPersonLift = /*#__PURE__*/React.forwardRef(function TwoPersonLift(_ref17, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref17;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M26.96 30l-1.9215-6.7253a1.0008 1.0008 0 01.3369-1.0554L29.874 18.62 28.52 13.2014l-2.7382 3.4234A1.0026 1.0026 0 0125 17H20V15h4.52l3.6993-4.6248a1 1 0 011.7509.3824l2 8a.9989.9989 0 01-.3447 1.0232l-4.48 3.5845 1.7389 6.0854zM23 5.5A3.5 3.5 0 1126.5 9 3.5042 3.5042 0 0123 5.5zm2 0A1.5 1.5 0 1026.5 4 1.5017 1.5017 0 0025 5.5z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0039,19A2.0039,2.0039,0,0,1,18,16.9961V15.0039A2.0039,2.0039,0,0,1,20.0039,13H22V10H10v3h1.9961A2.0039,2.0039,0,0,1,14,15.0039v1.9922A2.0039,2.0039,0,0,1,11.9961,19H10v3H22V19Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04 30l1.9215-6.7253a1.0013 1.0013 0 00-.3369-1.0555L2.126 18.62l1.3545-5.4185 2.7382 3.4234A1.0026 1.0026 0 007 17h5V15H7.4805L3.7812 10.3752a1 1 0 00-1.7509.3824l-2 8A.9989.9989 0 00.375 19.7808l4.4805 3.5844-1.739 6.0855zM5.5 9A3.5 3.5 0 119 5.5 3.5042 3.5042 0 015.5 9zm0-5A1.5 1.5 0 107 5.5 1.5017 1.5017 0 005.5 4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TwoPersonLift.propTypes = iconPropTypes;
}
const Txt = /*#__PURE__*/React.forwardRef(function Txt(_ref18, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref18;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M21 11L24 11 24 23 26 23 26 11 29 11 29 9 21 9 21 11zM20 9L18 9 16 15 14 9 12 9 14.75 16 12 23 14 23 16 17 18 23 20 23 17.25 16 20 9zM3 11L6 11 6 23 8 23 8 11 11 11 11 9 3 9 3 11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Txt.propTypes = iconPropTypes;
}
const TxtReference = /*#__PURE__*/React.forwardRef(function TxtReference(_ref19, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref19;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM21 4L24 4 24 16 26 16 26 4 29 4 29 2 21 2 21 4zM20 2L18 2 16 8 14 2 12 2 14.752 9 12 16 14 16 16 10 18 16 20 16 17.245 9 20 2zM3 4L6 4 6 16 8 16 8 4 11 4 11 2 3 2 3 4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TxtReference.propTypes = iconPropTypes;
}
const TypePattern = /*#__PURE__*/React.forwardRef(function TypePattern(_ref20, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref20;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M30 15L17 15 17 2 15 2 15 15 2 15 2 17 15 17 15 30 17 30 17 17 30 17 30 15z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M25.586 20L27 21.414 23.414 25 27 28.586 25.586 30 20.586 25 25.586 20zM11 30H3a1 1 0 01-.8945-1.4473l4-8a1.0412 1.0412 0 011.789 0l4 8A1 1 0 0111 30zM4.6182 28H9.3818L7 23.2363zM28 12H22a2.0023 2.0023 0 01-2-2V4a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2v6A2.0023 2.0023 0 0128 12zM22 4v6h6.001L28 4zM7 12a5 5 0 115-5A5.0059 5.0059 0 017 12zM7 4a3 3 0 103 3A3.0033 3.0033 0 007 4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  TypePattern.propTypes = iconPropTypes;
}
const Types = /*#__PURE__*/React.forwardRef(function Types(_ref21, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref21;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M30 16L22 24 20.586 22.586 27.172 16 20.586 9.414 22 8 30 16z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a.9967.9967,0,0,1-.707-.293l-5-5a.9994.9994,0,0,1,0-1.414l5-5a.9994.9994,0,0,1,1.414,0l5,5a.9994.9994,0,0,1,0,1.414l-5,5A.9967.9967,0,0,1,16,22Zm-3.5859-6L16,19.5859,19.5859,16,16,12.4141Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M2 16L10 8 11.414 9.414 4.828 16 11.414 22.586 10 24 2 16z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Types.propTypes = iconPropTypes;
}
const QU1 = /*#__PURE__*/React.forwardRef(function QU1(_ref22, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref22;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M13 23H9a2 2 0 01-2-2V9H9V21h4V9h2V21A2 2 0 0113 23zM22 21L22 9 17 9 17 11 20 11 20 21 17 21 17 23 25 23 25 21 22 21z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  QU1.propTypes = iconPropTypes;
}
const QU2 = /*#__PURE__*/React.forwardRef(function QU2(_ref23, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref23;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M13 23H9a2 2 0 01-2-2V9H9V21h4V9h2V21A2 2 0 0113 23zM25 23H17V17a2 2 0 012-2h4V11H17V9h6a2 2 0 012 2v4a2 2 0 01-2 2H19v4h6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  QU2.propTypes = iconPropTypes;
}
const QU3 = /*#__PURE__*/React.forwardRef(function QU3(_ref24, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref24;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M13 23H9a2 2 0 01-2-2V9H9V21h4V9h2V21A2 2 0 0113 23zM23 9H17v2h6v4H18v2h5v4H17v2h6a2 2 0 002-2V11A2 2 0 0023 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  QU3.propTypes = iconPropTypes;
}
const Umbrella = /*#__PURE__*/React.forwardRef(function Umbrella(_ref25, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref25;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9854,15.83A14.3808,14.3808,0,0,0,17,4.0464V2H15V4.0464A14.3808,14.3808,0,0,0,2.0146,15.83,1,1,0,0,0,3.51,16.86,4.8551,4.8551,0,0,1,6,16a4.8653,4.8653,0,0,1,4.1406,2.5107,1.0393,1.0393,0,0,0,1.7188,0A5.02,5.02,0,0,1,15,16.1255V25.5a2.5,2.5,0,0,1-5,0V25H8v.5a4.5,4.5,0,0,0,9,0V16.1255a5.02,5.02,0,0,1,3.1406,2.3852.9994.9994,0,0,0,1.7188,0A4.8653,4.8653,0,0,1,26,16a4.8551,4.8551,0,0,1,2.49.86,1,1,0,0,0,1.4957-1.03ZM6,14a5.4079,5.4079,0,0,0-1.5034.2134,12.4411,12.4411,0,0,1,8.488-7.8145A14.5157,14.5157,0,0,0,9.939,15.333,6.5439,6.5439,0,0,0,6,14Zm10,0a6.5528,6.5528,0,0,0-4.0564,1.4307c.0378-2.22.6089-6.49,4.0563-9.1763,3.4308,2.6768,4.0091,6.9487,4.0525,9.1728A6.553,6.553,0,0,0,16,14Zm10,0a6.5439,6.5439,0,0,0-3.939,1.333,14.5164,14.5164,0,0,0-3.0456-8.9341,12.4411,12.4411,0,0,1,8.488,7.8145A5.4079,5.4079,0,0,0,26,14Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Umbrella.propTypes = iconPropTypes;
}
const Undefined = /*#__PURE__*/React.forwardRef(function Undefined(_ref26, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref26;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M11 14H21V18H11z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2c-0.533,0-1.067,0.203-1.473,0.609L2.609,14.527 C2.203,14.933,2,15.466,2,16s0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30c0.533,0,1.067-0.203,1.473-0.609 l11.917-11.917C29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M16,28.036L3.965,16L16,3.964L28.036,16L16,28.036z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Undefined.propTypes = iconPropTypes;
}
const UndefinedFilled = /*#__PURE__*/React.forwardRef(function UndefinedFilled(_ref27, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref27;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2s-1.067,0.203-1.473,0.609L2.609,14.527C2.203,14.933,2,15.466,2,16 s0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30s1.067-0.203,1.473-0.609l11.917-11.917 C29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M21,18H11v-4h10V18z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M11 14H21V18H11z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UndefinedFilled.propTypes = iconPropTypes;
}
const Undo = /*#__PURE__*/React.forwardRef(function Undo(_ref28, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref28;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M20,10H7.8149l3.5874-3.5859L10,5,4,11,10,17l1.4023-1.4146L7.8179,12H20a6,6,0,0,1,0,12H12v2h8a8,8,0,0,0,0-16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Undo.propTypes = iconPropTypes;
}
const UngroupObjects = /*#__PURE__*/React.forwardRef(function UngroupObjects(_ref29, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref29;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M30,14V10H26v2H20V6h2V2H18V4H6V2H2V6H4V18H2v4H6V20h6v6H10v4h4V28H26v2h4V26H28V14ZM6,6H18V18H6ZM26,26H14V20h4v2h4V18H20V14h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UngroupObjects.propTypes = iconPropTypes;
}
const Unknown = /*#__PURE__*/React.forwardRef(function Unknown(_ref30, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref30;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "22.5",
    r: "1.5"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M17,19h-2v-4h2c1.103,0,2-0.897,2-2s-0.897-2-2-2h-2c-1.103,0-2,0.897-2,2v0.5h-2V13c0-2.206,1.794-4,4-4h2 c2.206,0,4,1.794,4,4s-1.794,4-4,4V19z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2c-0.533,0-1.067,0.203-1.473,0.609L2.609,14.527 C2.203,14.933,2,15.466,2,16s0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30c0.533,0,1.067-0.203,1.473-0.609 l11.917-11.917C29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M16,28.036L3.965,16L16,3.964L28.036,16L16,28.036z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Unknown.propTypes = iconPropTypes;
}
const UnknownFilled = /*#__PURE__*/React.forwardRef(function UnknownFilled(_ref31, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref31;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2s-1.067,0.203-1.473,0.609L2.609,14.527C2.203,14.933,2,15.466,2,16 s0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30s1.067-0.203,1.473-0.609l11.917-11.917 C29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M16,24c-0.828,0-1.5-0.671-1.5-1.5S15.172,21,16,21s1.5,0.671,1.5,1.5 S16.828,24,16,24z M17.125,17.248v1.877h-2.25V15H17c1.034,0,1.875-0.841,1.875-1.875S18.034,11.25,17,11.25h-2 c-1.034,0-1.875,0.841-1.875,1.875v0.5h-2.25v-0.5C10.875,10.851,12.726,9,15,9h2c2.274,0,4.125,1.851,4.125,4.125 C21.125,15.358,19.342,17.182,17.125,17.248z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16,21c0.828,0,1.5,0.672,1.5,1.5S16.828,24,16,24c-0.828,0-1.5-0.672-1.5-1.5S15.172,21,16,21 z M17.125,17.248c2.217-0.066,4-1.89,4-4.123C21.125,10.851,19.274,9,17,9h-2c-2.274,0-4.125,1.851-4.125,4.125v0.5h2.25v-0.5 c0-1.034,0.841-1.875,1.875-1.875h2c1.034,0,1.875,0.841,1.875,1.875S18.034,15,17,15h-2.125v4.125h2.25V17.248z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UnknownFilled.propTypes = iconPropTypes;
}
const Unlink = /*#__PURE__*/React.forwardRef(function Unlink(_ref32, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref32;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M5 3.59H7V8.42H5z",
    transform: "rotate(-45.01 5.996 6.005)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M25 23.58H27V28.409999999999997H25z",
    transform: "rotate(-44.99 25.995 25.999)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2H13V6H11zM2 11H6V13H2zM26 19H30V21H26zM19 26H21V30H19zM16.58 21.07l-3.71 3.72a4 4 0 11-5.66-5.66l3.72-3.72L9.51 14 5.8 17.72a6 6 0 00-.06 8.54A6 6 0 0010 28a6.07 6.07 0 004.32-1.8L18 22.49zM15.41 10.93l3.72-3.72a4 4 0 115.66 5.66l-3.72 3.72L22.49 18l3.71-3.72a6 6 0 00.06-8.54A6 6 0 0022 4a6.07 6.07 0 00-4.32 1.8L14 9.51z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Unlink.propTypes = iconPropTypes;
}
const Unlocked = /*#__PURE__*/React.forwardRef(function Unlocked(_ref33, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref33;
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
      d: "M12,7H6V4c0-1.1,0.9-2,2-2s2,0.9,2,2h1c0-1.7-1.3-3-3-3S5,2.3,5,4v3H4C3.4,7,3,7.4,3,8v6c0,0.6,0.4,1,1,1h8c0.6,0,1-0.4,1-1 V8C13,7.4,12.6,7,12,7z M12,14H4V8h8V14z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M24,14H12V8a4,4,0,0,1,8,0h2A6,6,0,0,0,10,8v6H8a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V16A2,2,0,0,0,24,14Zm0,14H8V16H24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Unlocked.propTypes = iconPropTypes;
}
const Unsaved = /*#__PURE__*/React.forwardRef(function Unsaved(_ref34, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref34;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M30 19.4L28.6 18 25 21.6 21.4 18 20 19.4 23.6 23 20 26.6 21.4 28 25 24.4 28.6 28 30 26.6 26.4 23z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M16,26l-4,0v-8l4,0v-2l-4,0c-1.1,0-2,0.9-2,2v8H6V6h4v4c0,1.1,0.9,2,2,2h8c1.1,0,2-0.9,2-2V6.4l4,4l0,5.6h2l0-6 c0-0.3-0.1-0.5-0.3-0.7l-5-5C22.5,4.1,22.3,4,22,4H6C4.9,4,4,4.9,4,6v20c0,1.1,0.9,2,2,2l10,0V26z M12,6h8v4h-8V6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Unsaved.propTypes = iconPropTypes;
}
const UpToTop = /*#__PURE__*/React.forwardRef(function UpToTop(_ref35, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref35;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14L6 24 7.4 25.4 16 16.8 24.6 25.4 26 24zM4 8H28V10H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UpToTop.propTypes = iconPropTypes;
}
const UpdateNow = /*#__PURE__*/React.forwardRef(function UpdateNow(_ref36, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref36;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M27 25.586L25 23.586 25 21 23 21 23 24.414 25.586 27 27 25.586z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M24 31a7 7 0 117-7A7.0078 7.0078 0 0124 31zm0-12a5 5 0 105 5A5.0055 5.0055 0 0024 19zM16 28A12.0134 12.0134 0 014 16H2A14.0158 14.0158 0 0016 30zM12 8H7.0784A11.9843 11.9843 0 0128 16h2A13.9778 13.9778 0 006 6.2344V2H4v8h8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UpdateNow.propTypes = iconPropTypes;
}
const Upgrade = /*#__PURE__*/React.forwardRef(function Upgrade(_ref37, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref37;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M21 24H11a2 2 0 00-2 2v2a2 2 0 002 2H21a2 2 0 002-2V26A2 2 0 0021 24zm0 4H11V26H21zM28.707 14.293l-12-12a.9994.9994 0 00-1.414 0l-12 12A1 1 0 004 16H9v4a2.0023 2.0023 0 002 2H21a2.0027 2.0027 0 002-2V16h5a1 1 0 00.707-1.707zM21 14v6H11V14H6.4141L16 4.4141 25.5859 14z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Upgrade.propTypes = iconPropTypes;
}
const Upload = /*#__PURE__*/React.forwardRef(function Upload(_ref38, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref38;
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
      d: "M3 9L3.7 9.7 7.5 5.9 7.5 15 8.5 15 8.5 5.9 12.3 9.7 13 9 8 4zM3 4V2h10v2h1V2c0-.6-.4-1-1-1H3C2.4 1 2 1.4 2 2v2H3z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18L7.41 19.41 15 11.83 15 30 17 30 17 11.83 24.59 19.41 26 18 16 8 6 18zM6 8V4H26V8h2V4a2 2 0 00-2-2H6A2 2 0 004 4V8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Upload.propTypes = iconPropTypes;
}
const Upstream = /*#__PURE__*/React.forwardRef(function Upstream(_ref39, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref39;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M10 24c0 3.3137 2.6863 6 6 6s6-2.6863 6-6-2.6863-6-6-6-6 2.6863-6 6zm2 0c0-2.2056 1.7944-4 4-4s4 1.7944 4 4-1.7944 4-4 4-4-1.7944-4-4zM30 5c0-1.6567-1.3433-3-3-3s-3 1.3433-3 3c0 1.3042.8374 2.4028 2 2.8164v5.1836c0 1.7217-.752 3.3438-2 4.4673v-2.4673h-2v6h6v-2h-2.7168c1.6938-1.4995 2.7168-3.6816 2.7168-6v-5.1836c1.1626-.4136 2-1.5122 2-2.8164zm-3 1c-.5522 0-1-.4478-1-1s.4478-1 1-1 1 .4478 1 1-.4478 1-1 1zM18.586 11.5859l-1.5859 1.5859v-5.3555c1.1626-.4136 2-1.5122 2-2.8164 0-1.6567-1.3433-3-3-3s-3 1.3433-3 3c0 1.3042.8374 2.4028 2 2.8164v5.3555l-1.5859-1.5859-1.4141 1.4141 4 4 4-4-1.4141-1.4141zm-2.5859-7.5859c.5522 0 1 .4478 1 1s-.4478 1-1 1-1-.4478-1-1 .4478-1 1-1zM8 15v2.4673c-1.248-1.1235-2-2.7456-2-4.4673v-5.1836c1.1626-.4136 2-1.5122 2-2.8164 0-1.6567-1.3433-3-3-3s-3 1.3433-3 3c0 1.3042.8374 2.4028 2 2.8164v5.1836c0 2.3184 1.0229 4.5005 2.7168 6h-2.7168v2h6v-6h-2zm-3-11c.5522 0 1 .4478 1 1s-.4478 1-1 1-1-.4478-1-1 .4478-1 1-1z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Upstream.propTypes = iconPropTypes;
}
const Url = /*#__PURE__*/React.forwardRef(function Url(_ref40, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref40;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M24 21L24 9 22 9 22 23 30 23 30 21 24 21zM20 15v-4c0-1.103-.8975-2-2-2h-6v14h2v-6h1.4807l2.3345 6h2.1453l-2.3331-6h.3726c1.1025 0 2-.8975 2-2zm-6-4h4v4h-4v-4zM8 23h-4c-1.103 0-2-.8975-2-2v-12h2v12h4v-12h2v12c0 1.1025-.897 2-2 2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Url.propTypes = iconPropTypes;
}
const Usb = /*#__PURE__*/React.forwardRef(function Usb(_ref41, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref41;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M24,15V6a2,2,0,0,0-2-2H10A2,2,0,0,0,8,6v9a2,2,0,0,0-2,2V28H8V17H24V28h2V17A2,2,0,0,0,24,15ZM10,6H22v9H10Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10H15V12H12zM17 10H20V12H17z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Usb.propTypes = iconPropTypes;
}
const User = /*#__PURE__*/React.forwardRef(function User(_ref42, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref42;
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
      d: "M8 2c1.4 0 2.5 1.1 2.5 2.5S9.4 7 8 7 5.5 5.9 5.5 4.5 6.6 2 8 2M8 1C6.1 1 4.5 2.6 4.5 4.5S6.1 8 8 8s3.5-1.6 3.5-3.5S9.9 1 8 1zM13 15h-1v-2.5c0-1.4-1.1-2.5-2.5-2.5h-3C5.1 10 4 11.1 4 12.5V15H3v-2.5C3 10.6 4.6 9 6.5 9h3c1.9 0 3.5 1.6 3.5 3.5V15z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0016 2zM26 30H24V25a5 5 0 00-5-5H13a5 5 0 00-5 5v5H6V25a7 7 0 017-7h6a7 7 0 017 7z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  User.propTypes = iconPropTypes;
}
const UserAccess = /*#__PURE__*/React.forwardRef(function UserAccess(_ref43, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref43;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8zM30 12a1.9922 1.9922 0 00-.5117.0742L28.4331 11.019a3.8788 3.8788 0 000-4.038l1.0552-1.0552a2.0339 2.0339 0 10-1.4141-1.4141L27.019 5.5669a3.8788 3.8788 0 00-4.038 0L21.9258 4.5117a2.0339 2.0339 0 10-1.4141 1.4141L21.5669 6.981a3.8788 3.8788 0 000 4.038l-1.0552 1.0552a2.0339 2.0339 0 101.4141 1.4141l1.0552-1.0552a3.8788 3.8788 0 004.038 0l1.0552 1.0552A1.9957 1.9957 0 1030 12zM23 9a2 2 0 112 2A2.0025 2.0025 0 0123 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserAccess.propTypes = iconPropTypes;
}
const UserActivity = /*#__PURE__*/React.forwardRef(function UserActivity(_ref44, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref44;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M25 23h-.0215a1.0016 1.0016 0 01-.94-.7256L20.8711 11.19l-1.9346 5.1607A1.0005 1.0005 0 0118 17H14V15h3.3066l2.7569-7.3511a1.0005 1.0005 0 011.8984.0762l3.1113 10.8921 1.9786-5.9336A.9988.9988 0 0128 12h4v2H28.7207l-2.7725 8.3164A.9984.9984 0 0125 23zM15 30H13V23a3.0033 3.0033 0 00-3-3H6a3.0033 3.0033 0 00-3 3v7H1V23a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM8 8a3 3 0 11-3 3A3 3 0 018 8M8 6a5 5 0 105 5A5 5 0 008 6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserActivity.propTypes = iconPropTypes;
}
const UserAdmin = /*#__PURE__*/React.forwardRef(function UserAdmin(_ref45, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref45;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7zM25 16.18L22.41 13.59 21 15 25 19 32 12 30.59 10.59 25 16.18z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserAdmin.propTypes = iconPropTypes;
}
const UserAvatar = /*#__PURE__*/React.forwardRef(function UserAvatar(_ref46, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref46;
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
      d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M5,13.2v-1.5c0-0.9,0.6-1.6,1.5-1.7h3c0.9,0.1,1.5,0.8,1.5,1.7v1.5 C9.1,14.3,6.9,14.3,5,13.2L5,13.2z M12,12l0-0.8c0-0.9-1.1-2.1-2.5-2.2h-3C5.1,9.1,4,10.3,4,11.7l0,0.5v0.3c-2.5-2.2-2.7-6-0.5-8.5 s6-2.7,8.5-0.5s2.7,6,0.5,8.5c-0.1,0.2-0.3,0.3-0.5,0.5V12z"
    })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
      d: "M8,3C6.6,3,5.5,4.1,5.5,5.5S6.6,8,8,8s2.5-1.1,2.5-2.5S9.4,3,8,3z M8,7C7.2,7,6.5,6.3,6.5,5.5S7.2,4,8,4s1.5,0.7,1.5,1.5 S8.8,7,8,7z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M16,8a5,5,0,1,0,5,5A5,5,0,0,0,16,8Zm0,8a3,3,0,1,1,3-3A3.0034,3.0034,0,0,1,16,16Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM10,26.3765V25a3.0033,3.0033,0,0,1,3-3h6a3.0033,3.0033,0,0,1,3,3v1.3765a11.8989,11.8989,0,0,1-12,0Zm13.9925-1.4507A5.0016,5.0016,0,0,0,19,20H13a5.0016,5.0016,0,0,0-4.9925,4.9258,12,12,0,1,1,15.985,0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserAvatar.propTypes = iconPropTypes;
}
const UserAvatarFilled = /*#__PURE__*/React.forwardRef(function UserAvatarFilled(_ref47, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref47;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M8.0071,24.93A4.9958,4.9958,0,0,1,13,20h6a4.9959,4.9959,0,0,1,4.9929,4.93,11.94,11.94,0,0,1-15.9858,0ZM20.5,12.5A4.5,4.5,0,1,1,16,8,4.5,4.5,0,0,1,20.5,12.5Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7489,24.93A13.9893,13.9893,0,1,0,2,16a13.899,13.899,0,0,0,3.2511,8.93l-.02.0166c.07.0845.15.1567.2222.2392.09.1036.1864.2.28.3008.28.3033.5674.5952.87.87.0915.0831.1864.1612.28.2417.32.2759.6484.5372.99.7813.0441.0312.0832.0693.1276.1006v-.0127a13.9011,13.9011,0,0,0,16,0V27.48c.0444-.0313.0835-.0694.1276-.1006.3412-.2441.67-.5054.99-.7813.0936-.08.1885-.1586.28-.2417.3025-.2749.59-.5668.87-.87.0933-.1006.1894-.1972.28-.3008.0719-.0825.1522-.1547.2222-.2392ZM16,8a4.5,4.5,0,1,1-4.5,4.5A4.5,4.5,0,0,1,16,8ZM8.0071,24.93A4.9957,4.9957,0,0,1,13,20h6a4.9958,4.9958,0,0,1,4.9929,4.93,11.94,11.94,0,0,1-15.9858,0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserAvatarFilled.propTypes = iconPropTypes;
}
const UserAvatarFilledAlt = /*#__PURE__*/React.forwardRef(function UserAvatarFilledAlt(_ref48, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref48;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M16,8a5,5,0,1,0,5,5A5,5,0,0,0,16,8Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm7.9925,22.9258A5.0016,5.0016,0,0,0,19,20H13a5.0016,5.0016,0,0,0-4.9925,4.9258,12,12,0,1,1,15.985,0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserAvatarFilledAlt.propTypes = iconPropTypes;
}
const UserCertification = /*#__PURE__*/React.forwardRef(function UserCertification(_ref49, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref49;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M25 10L26.593 13 30 13.414 27.5 15.667 28 19 25 17.125 22 19 22.5 15.667 20 13.414 23.5 13 25 10zM22 30H20V25a5.0059 5.0059 0 00-5-5H9a5.0059 5.0059 0 00-5 5v5H2V25a7.0082 7.0082 0 017-7h6a7.0082 7.0082 0 017 7zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserCertification.propTypes = iconPropTypes;
}
const UserData = /*#__PURE__*/React.forwardRef(function UserData(_ref50, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref50;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M28 8H30V16H28zM23 5H25V16H23zM18 10H20V16H18zM16 30H14V24a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v6H2V24a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 9a3 3 0 11-3 3A3 3 0 019 9M9 7a5 5 0 105 5A5 5 0 009 7z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserData.propTypes = iconPropTypes;
}
const UserFavorite = /*#__PURE__*/React.forwardRef(function UserFavorite(_ref51, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref51;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M27.303 12a2.6616 2.6616 0 00-1.9079.8058l-.3932.4054-.397-.4054a2.6615 2.6615 0 00-3.8157 0 2.7992 2.7992 0 000 3.8964L25.0019 21l4.2089-4.2978a2.7992 2.7992 0 000-3.8964A2.6616 2.6616 0 0027.303 12zM2 30H4V25a5.0059 5.0059 0 015-5h6a5.0059 5.0059 0 015 5v5h2V25a7.0082 7.0082 0 00-7-7H9a7.0082 7.0082 0 00-7 7zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserFavorite.propTypes = iconPropTypes;
}
const UserFavoriteAlt = /*#__PURE__*/React.forwardRef(function UserFavoriteAlt(_ref52, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref52;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7663 4.2558A4.2121 4.2121 0 0023 4.0321a4.2121 4.2121 0 00-5.7663.2237 4.319 4.319 0 000 6.0447L22.998 16.14 23 16.1376l.002.0019 5.7643-5.839A4.319 4.319 0 0028.7663 4.2558zM27.342 8.8948l-4.34 4.3973L23 13.29l-.002.002-4.34-4.3973a2.3085 2.3085 0 010-3.2338 2.2639 2.2639 0 013.1561 0l1.181 1.2074L23 6.8634l.0049.005 1.181-1.2074a2.2639 2.2639 0 013.1561 0A2.3085 2.3085 0 0127.342 8.8948zM16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserFavoriteAlt.propTypes = iconPropTypes;
}
const UserFavoriteAltFilled = /*#__PURE__*/React.forwardRef(function UserFavoriteAltFilled(_ref53, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref53;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4938 3a3.4735 3.4735 0 00-2.48 1.0393l-.5111.5228-.5161-.5228a3.4792 3.4792 0 00-4.96 0 3.59 3.59 0 000 5.0251l5.4766 5.5427 5.4716-5.5427a3.59 3.59 0 000-5.0251A3.4738 3.4738 0 0026.4938 3zM16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserFavoriteAltFilled.propTypes = iconPropTypes;
}
const UserFilled = /*#__PURE__*/React.forwardRef(function UserFilled(_ref54, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref54;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M6 30H26V25a7.0082 7.0082 0 00-7-7H13a7.0082 7.0082 0 00-7 7zM9 9a7 7 0 107-7A7 7 0 009 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserFilled.propTypes = iconPropTypes;
}
const UserFollow = /*#__PURE__*/React.forwardRef(function UserFollow(_ref55, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref55;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M32 14L28 14 28 10 26 10 26 14 22 14 22 16 26 16 26 20 28 20 28 16 32 16 32 14zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserFollow.propTypes = iconPropTypes;
}
const UserIdentification = /*#__PURE__*/React.forwardRef(function UserIdentification(_ref56, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref56;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M22,11h4a1,1,0,0,1,1,1v2a0,0,0,0,1,0,0H21a0,0,0,0,1,0,0V12A1,1,0,0,1,22,11Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "8",
    r: "2"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M30 18H18a2.0023 2.0023 0 01-2-2V4a2.002 2.002 0 012-2H30a2.0023 2.0023 0 012 2V16A2.0027 2.0027 0 0130 18zM18 4V16H30.001L30 4zM15 30H13V26a2.9465 2.9465 0 00-3-3H6a2.9465 2.9465 0 00-3 3v4H1V26a4.9514 4.9514 0 015-5h4a4.9514 4.9514 0 015 5zM8 11a3 3 0 010 6 3 3 0 010-6M8 9A5 5 0 008 19 5 5 0 008 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserIdentification.propTypes = iconPropTypes;
}
const UserMilitary = /*#__PURE__*/React.forwardRef(function UserMilitary(_ref57, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref57;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M25 13L23.407 16 20 16.414 22.5 18.667 22 22 25 20.125 28 22 27.5 18.667 30 16.414 26.5 16 25 13z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M21.414 13.414L25 9.834 25 9.834 28.587 13.416 30 12 25 7 20 12 21.414 13.414z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M21.414 8.414L25 4.834 25 4.834 28.587 8.416 30 7 25 2 20 7 21.414 8.414zM16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserMilitary.propTypes = iconPropTypes;
}
const UserMultiple = /*#__PURE__*/React.forwardRef(function UserMultiple(_ref58, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref58;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M30 30H28V25a5.0057 5.0057 0 00-5-5V18a7.0078 7.0078 0 017 7zM22 30H20V25a5.0059 5.0059 0 00-5-5H9a5.0059 5.0059 0 00-5 5v5H2V25a7.0082 7.0082 0 017-7h6a7.0082 7.0082 0 017 7zM20 2V4a5 5 0 010 10v2A7 7 0 0020 2zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserMultiple.propTypes = iconPropTypes;
}
const UserOnline = /*#__PURE__*/React.forwardRef(function UserOnline(_ref59, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref59;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "26",
    cy: "16",
    r: "4"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserOnline.propTypes = iconPropTypes;
}
const UserProfile = /*#__PURE__*/React.forwardRef(function UserProfile(_ref60, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref60;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7zM22 4H32V6H22zM22 9H32V11H22zM22 14H29V16H22z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserProfile.propTypes = iconPropTypes;
}
const UserRole = /*#__PURE__*/React.forwardRef(function UserRole(_ref61, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref61;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M28.07 21L22 15 28.07 9 29.5 10.41 24.86 15 29.5 19.59 28.07 21zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserRole.propTypes = iconPropTypes;
}
const UserServiceDesk = /*#__PURE__*/React.forwardRef(function UserServiceDesk(_ref62, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref62;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M25.334 11.95l1.2055-1.206a1.178 1.178 0 011.2593-.2584l1.4693.5868A1.1736 1.1736 0 0130 12.1489v2.692A1.1681 1.1681 0 0128.8229 16l-.05-.0015C18.4775 15.3578 16.4 6.6357 16.0073 3.2976a1.1681 1.1681 0 011.0315-1.29A1.1492 1.1492 0 0117.1751 2h2.5994a1.1626 1.1626 0 011.0764.7322l.5866 1.47a1.1635 1.1635 0 01-.2529 1.26L19.9791 6.668S20.6733 11.3682 25.334 11.95zM16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserServiceDesk.propTypes = iconPropTypes;
}
const UserSettings = /*#__PURE__*/React.forwardRef(function UserSettings(_ref63, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref63;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M30 10V8H27.8989a4.9678 4.9678 0 00-.7319-1.7529l1.49-1.49-1.414-1.414-1.49 1.49A4.9678 4.9678 0 0024 4.1011V2H22V4.1011a4.9678 4.9678 0 00-1.7529.7319l-1.49-1.49-1.414 1.414 1.49 1.49A4.9678 4.9678 0 0018.1011 8H16v2h2.1011a4.9678 4.9678 0 00.7319 1.7529l-1.49 1.49 1.414 1.414 1.49-1.49A4.9678 4.9678 0 0022 13.8989V16h2V13.8989a4.9678 4.9678 0 001.7529-.7319l1.49 1.49 1.414-1.414-1.49-1.49A4.9678 4.9678 0 0027.8989 10zm-7 2a3 3 0 113-3A3.0033 3.0033 0 0123 12zM16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserSettings.propTypes = iconPropTypes;
}
const UserSimulation = /*#__PURE__*/React.forwardRef(function UserSimulation(_ref64, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref64;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M25.232 12.866H29.232V14.866H25.232z",
    transform: "rotate(30 27.232 13.866)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M26 8H30V10H26z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M2.768 12.866H6.768V14.866H2.768z",
    transform: "rotate(150 4.768 13.866)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M26 30H24V25a5.0059 5.0059 0 00-5-5H13a5.0059 5.0059 0 00-5 5v5H6V25a7.0082 7.0082 0 017-7h6a7.0082 7.0082 0 017 7zM16 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0016 2z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M25.232 3.134H29.232V5.134H25.232z",
    transform: "rotate(-30 27.232 4.134)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8H6V10H2z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M2.768 3.134H6.768V5.134H2.768z",
    transform: "rotate(-150 4.768 4.134)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserSimulation.propTypes = iconPropTypes;
}
const UserSpeaker = /*#__PURE__*/React.forwardRef(function UserSpeaker(_ref65, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref65;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4146,19,27.7,17.2852A2.97,2.97,0,0,0,28,16a3,3,0,1,0-3,3,2.97,2.97,0,0,0,1.2864-.3L28,20.4141V28H22V25a7.0078,7.0078,0,0,0-7-7H9a7.008,7.008,0,0,0-7,7v5H30V20.4141A1.988,1.988,0,0,0,29.4146,19ZM4,25a5.006,5.006,0,0,1,5-5h6a5.0059,5.0059,0,0,1,5,5v3H4Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M12,4A5,5,0,1,1,7,9a5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,12,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserSpeaker.propTypes = iconPropTypes;
}
const UserSponsor = /*#__PURE__*/React.forwardRef(function UserSponsor(_ref66, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref66;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8301 13.3662L30.8301 11.6338 28 13.2681 28 10 26 10 26 13.2676 23.1699 11.6338 22.1699 13.3662 25 15 22.1699 16.6338 23.1699 18.3662 26 16.7324 26 20 28 20 28 16.7319 30.8301 18.3662 31.8301 16.6338 29 15 31.8301 13.3662zM22 30h-2v-5c-.0033-2.7601-2.2399-4.9967-5-5h-6c-2.7601.0033-4.9967 2.2399-5 5v5h-2v-5c.0045-3.8641 3.1359-6.9955 7-7h6c3.8641.0045 6.9955 3.1359 7 7v5zM12 4c2.7614 0 5 2.2386 5 5s-2.2386 5-5 5-5-2.2386-5-5c.0031-2.7601 2.2399-4.9969 5-5m0-2c-3.866 0-7 3.134-7 7s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserSponsor.propTypes = iconPropTypes;
}
const UserXRay = /*#__PURE__*/React.forwardRef(function UserXRay(_ref67, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref67;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M28 9L28 7 25 7 25 5 23 5 23 7 20 7 20 9 23 9 23 12 20 12 20 14 23 14 23 16 25 16 25 14 28 14 28 12 25 12 25 9 28 9z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M31 3H17a1 1 0 00-1 1V17a1 1 0 001 1H31a1 1 0 001-1V4A1 1 0 0031 3zM28 9H25v3h3v2H25v2H23V14H20V12h3V9H20V7h3V5h2V7h3zM15 30H13V26a2.9465 2.9465 0 00-3-3H6a2.9465 2.9465 0 00-3 3v4H1V26a4.9514 4.9514 0 015-5h4a4.9514 4.9514 0 015 5zM8 11a3 3 0 010 6 3 3 0 010-6M8 9A5 5 0 008 19 5 5 0 008 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserXRay.propTypes = iconPropTypes;
}
const UserProfileAlt = /*#__PURE__*/React.forwardRef(function UserProfileAlt(_ref68, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref68;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M19 13H26V15H19zM19 8H30V10H19zM19 3H30V5H19zM11 30H7a2.0059 2.0059 0 01-2-2V21a2.0059 2.0059 0 01-2-2V13a2.9465 2.9465 0 013-3h6a2.9465 2.9465 0 013 3v6a2.0059 2.0059 0 01-2 2v7A2.0059 2.0059 0 0111 30zM6 12a.9448.9448 0 00-1 1v6H7v9h4V19h2V13a.9448.9448 0 00-1-1zM9 9a4 4 0 114-4h0A4.0118 4.0118 0 019 9zM9 3a2 2 0 102 2h0A2.0059 2.0059 0 009 3z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UserProfileAlt.propTypes = iconPropTypes;
}
const UvIndex = /*#__PURE__*/React.forwardRef(function UvIndex(_ref69, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref69;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M16,5.9121l1.7444,2.9326.7822,1.315,1.4739-.4107,3.1206-.87L22.2512,12,21.84,13.4731l1.315.7823L26.0876,16l-2.9323,1.7441-1.315.7818L22.2512,20l.87,3.1211-3.1208-.87L18.5266,21.84l-.7822,1.315L16,26.0879l-1.7444-2.9326-.7822-1.315L12,22.251l-3.1208.87L9.7488,20l.4109-1.4741-1.315-.7818L5.9124,16l2.9323-1.7446,1.315-.7823L9.7488,12l-.87-3.1206L12,9.749l1.4739.4107.7822-1.315L16,5.9121M16,2,12.5366,7.8223,6,6l1.8223,6.5366L2,16l5.8223,3.4629L6,26l6.5366-1.8223L16,30l3.4634-5.8223L26,26l-1.8223-6.5371L30,16l-5.8223-3.4634L26,6,19.4634,7.8223,16,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UvIndex.propTypes = iconPropTypes;
}
const UvIndexAlt = /*#__PURE__*/React.forwardRef(function UvIndexAlt(_ref70, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref70;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M13 30H9a2.0027 2.0027 0 01-2-2V20H9v8h4V20h2v8A2.0027 2.0027 0 0113 30zM25 20L23.25 20 21 29.031 18.792 20 17 20 19.5 30 22.5 30 25 20zM15 2H17V7H15z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M21.668 6.854H26.625999999999998V8.854H21.668z",
    transform: "rotate(-45 24.147 7.853)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M25 15H30V17H25zM2 15H7V17H2z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M6.854 5.375H8.854V10.333H6.854z",
    transform: "rotate(-45 7.854 7.853)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M22,17H20V16a4,4,0,0,0-8,0v1H10V16a6,6,0,0,1,12,0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UvIndexAlt.propTypes = iconPropTypes;
}
const UvIndexFilled = /*#__PURE__*/React.forwardRef(function UvIndexFilled(_ref71, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref71;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30l-3.4634-5.8223L6,26l1.8223-6.5369L2,16l5.8223-3.4631L6,6l6.5366,1.8223L16,2l3.4634,5.8223L26,6l-1.8223,6.5369L30,16l-5.8223,3.4631L26,26l-6.5366-1.8223Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  UvIndexFilled.propTypes = iconPropTypes;
}
const ValueVariable = /*#__PURE__*/React.forwardRef(function ValueVariable(_ref72, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref72;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M26 28H22V26h4V6H22V4h4a2.0021 2.0021 0 012 2V26A2.0021 2.0021 0 0126 28zM20 11L18 11 16 14.897 14 11 12 11 14.905 16 12 21 14 21 16 17.201 18 21 20 21 17.098 16 20 11zM10 28H6a2.0021 2.0021 0 01-2-2V6A2.0021 2.0021 0 016 4h4V6H6V26h4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ValueVariable.propTypes = iconPropTypes;
}
const Van = /*#__PURE__*/React.forwardRef(function Van(_ref73, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref73;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M29.81,16l-7-9.56A1,1,0,0,0,22,6H3A1,1,0,0,0,2,7V24a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V16.56A1,1,0,0,0,29.81,16ZM20,8h1.49l5.13,7H20ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86a4,4,0,0,0-7.72,0H12.86a4,4,0,0,0-7.72,0H4V8H18v9H28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Van.propTypes = iconPropTypes;
}
const VegetationAsset = /*#__PURE__*/React.forwardRef(function VegetationAsset(_ref74, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref74;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "21.5",
    cy: "10.5",
    r: "1.5"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 1a2.4518 2.4518 0 00-1.2061.3105L18.9834 5.6084l.0027.0054a5.497 5.497 0 107.3257 7.5444l.0031.0015 4.4-8.5A2.5 2.5 0 0028.5 1zm-7 13A3.5 3.5 0 1125 10.5 3.5042 3.5042 0 0121.5 14zM28.9414 3.7354L26.5571 8.3408A5.5279 5.5279 0 0023.658 5.4424l4.5949-2.377A.5165.5165 0 0129 3.5.4985.4985 0 0128.9414 3.7354zM19 20h7V18H17V28a2.0027 2.0027 0 002 2h3V28H19zM12 30H9V28h3V15.5664L8.4854 13.4575l1.0292-1.7148 3.5147 2.1084A2.0115 2.0115 0 0114 15.5664V28A2.0024 2.0024 0 0112 30z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3079,2.2852A9.4882,9.4882,0,0,0,15,2,8.0275,8.0275,0,0,0,8.0786,6.001C8.0525,6,8.0264,6,8,6A6,6,0,0,0,8,18V16A4,4,0,0,1,8,8a2.7009,2.7009,0,0,1,.387.0391l.863.1142.3086-.6675A6.0192,6.0192,0,0,1,15,4a7.499,7.499,0,0,1,1.731.2148Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VegetationAsset.propTypes = iconPropTypes;
}
const VegetationEncroachment = /*#__PURE__*/React.forwardRef(function VegetationEncroachment(_ref75, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref75;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M19 20h7v-2h-9v10c.0015 1.104.896 1.9985 2 2h3v-2h-3v-8zM12 30h-3v-2h3v-12.4336l-3.5146-2.1089 1.0292-1.7148 3.5147 2.1084c.6007.3632.9686 1.0133.9707 1.7153v12.4336c-.0013 1.104-.896 1.9987-2 2zM30 6.4102L28.59 5 25 8.5898 21.41 5 20 6.4102 23.59 10 20 13.5898 21.41 15 25 11.4102 28.59 15 30 13.5898 26.41 10 30 6.4102z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "m17.3079,2.2852c-.7283-.1821-1.4995-.2852-2.3079-.2852-2.8545.0083-5.4897,1.5317-6.9214,4.001-.0261-.001-.0522-.001-.0786-.001-3.3137,0-6,2.6865-6,6s2.6863,6,6,6v-2c-2.209,0-4-1.791-4-4s1.791-4,4-4c.1299.0039.259.0166.387.0391l.863.1143.3086-.6675c.9834-2.1196,3.1047-3.4785,5.4414-3.4858.6079,0,1.1819.0854,1.731.2148l.5769-1.9297Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VegetationEncroachment.propTypes = iconPropTypes;
}
const VegetationHeight = /*#__PURE__*/React.forwardRef(function VegetationHeight(_ref76, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref76;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "m13,8l-5,5,1.4102,1.4102,2.5898-2.5801v16.1699h-3v2h3c1.104-.0015,1.9988-.896,2-2V11.8301l2.5898,2.5801,1.4102-1.4102-5-5Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "m22,30h-3c-1.104-.0013-1.9987-.896-2-2v-11h6c2.2096-.0001,4.0007-1.7915,4.0006-4.001,0-.1319-.0065-.2637-.0196-.395-.277-2.0943-2.0835-3.6461-4.1957-3.604h-1.5837l-.1766-.779c-.573-2.5249-2.9942-4.221-6.025-4.221-2.3366.0074-4.4579,1.3664-5.4415,3.4859l-.3085.6672-.863-.1143c-.1279-.022-.2573-.0349-.387-.0388-2.2091,0-4,1.7909-4,4s1.7909,4,4,4v2c-3.3137,0-6-2.6863-6-6s2.6863-6,6-6c.0264,0,.0525,0,.0786.001,1.4317-2.4694,4.067-3.9928,6.9214-4.001,3.6788,0,6.6923,1.9776,7.7516,5h.0337c3.1405-.0351,5.8053,2.2967,6.1872,5.4141.323,3.2985-2.0892,6.2344-5.3877,6.5573-.1943.019-.3895.0286-.5848.0286h-4v9h3v2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VegetationHeight.propTypes = iconPropTypes;
}
const VehicleApi = /*#__PURE__*/React.forwardRef(function VehicleApi(_ref77, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref77;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M28 11a1.9907 1.9907 0 00-.8247.1821L24.8337 9.51A3.45 3.45 0 0025 8.5a3.45 3.45 0 00-.1663-1.01l2.3416-1.6723A1.9975 1.9975 0 1026 4c0 .064.0129.124.0188.1865L23.7273 5.8232A3.4652 3.4652 0 0021.5 5a3.5 3.5 0 000 7 3.4652 3.4652 0 002.2273-.8232l2.2915 1.6367C26.0129 12.876 26 12.936 26 13a2 2 0 102-2zm-6.5-1A1.5 1.5 0 1123 8.5 1.5017 1.5017 0 0121.5 10zM29.3379 19.9336l-7.7324-2.7783L18.374 13.0967A2.99 2.99 0 0016.0537 12H8.0576a2.9982 2.9982 0 00-2.48 1.3115L2.8662 17.2949A4.9884 4.9884 0 002 20.1074V26a1 1 0 001 1H5.1421a3.9806 3.9806 0 007.7158 0h6.2842a3.9806 3.9806 0 007.7158 0H29a1 1 0 001-1V20.875A1 1 0 0029.3379 19.9336zM9 28a2 2 0 112-2A2.0027 2.0027 0 019 28zm14 0a2 2 0 112-2A2.0025 2.0025 0 0123 28zm5-3H26.8579a3.9806 3.9806 0 00-7.7158 0H12.8579a3.9806 3.9806 0 00-7.7158 0H4V20.1074A2.9977 2.9977 0 014.52 18.4189l2.711-3.9814A.9992.9992 0 018.0576 14h7.9961a.9928.9928 0 01.7647.3545l3.3994 4.2685a1.0007 1.0007 0 00.4443.3184L28 21.5781z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VehicleApi.propTypes = iconPropTypes;
}
const VehicleConnected = /*#__PURE__*/React.forwardRef(function VehicleConnected(_ref78, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref78;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3379 17.9336l-7.7324-2.7783L18.374 11.0967A2.99 2.99 0 0016.0537 10H8.0576a2.9982 2.9982 0 00-2.48 1.3115L2.8662 15.2949A4.9884 4.9884 0 002 18.1074V26a1 1 0 001 1H5.1421a3.9806 3.9806 0 007.7158 0h6.2842a3.9806 3.9806 0 007.7158 0H29a1 1 0 001-1V18.875A1 1 0 0029.3379 17.9336zM9 28a2 2 0 112-2A2.0027 2.0027 0 019 28zm14 0a2 2 0 112-2A2.0025 2.0025 0 0123 28zm5-3H26.8579a3.9806 3.9806 0 00-7.7158 0H12.8579a3.9806 3.9806 0 00-7.7158 0H4V18.1074A2.9977 2.9977 0 014.52 16.4189l2.711-3.9814A.9992.9992 0 018.0576 12h7.9961a.9928.9928 0 01.7647.3545l3.3994 4.2685a1.0007 1.0007 0 00.4443.3184L28 19.5781zM25 11H23a2.0021 2.0021 0 00-2-2V7A4.0045 4.0045 0 0125 11z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M29,11H27a6.0067,6.0067,0,0,0-6-6V3A8.0092,8.0092,0,0,1,29,11Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VehicleConnected.propTypes = iconPropTypes;
}
const VehicleInsights = /*#__PURE__*/React.forwardRef(function VehicleInsights(_ref79, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref79;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3379 17.9336l-7.7324-2.7783L18.374 11.0967A2.99 2.99 0 0016.0537 10H8.0576a2.9982 2.9982 0 00-2.48 1.3115L2.8662 15.2949A4.9884 4.9884 0 002 18.1074V26a1 1 0 001 1H5.1421a3.9806 3.9806 0 007.7158 0h6.2842a3.9806 3.9806 0 007.7158 0H29a1 1 0 001-1V18.875A1 1 0 0029.3379 17.9336zM9 28a2 2 0 112-2A2.0027 2.0027 0 019 28zm14 0a2 2 0 112-2A2.0025 2.0025 0 0123 28zm5-3H26.8579a3.9806 3.9806 0 00-7.7158 0H12.8579a3.9806 3.9806 0 00-7.7158 0H4V18.1074A2.9977 2.9977 0 014.52 16.4189l2.711-3.9814A.9992.9992 0 018.0576 12h7.9961a.9928.9928 0 01.7647.3545l3.3994 4.2685a1.0007 1.0007 0 00.4443.3184L28 19.5781zM28 2H30V9H28zM24 6H26V9H24zM20 4H22V9H20z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VehicleInsights.propTypes = iconPropTypes;
}
const VehicleServices = /*#__PURE__*/React.forwardRef(function VehicleServices(_ref80, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref80;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3379 17.9336l-7.7324-2.7783L18.374 11.0967A2.99 2.99 0 0016.0537 10H8.0576a2.9982 2.9982 0 00-2.48 1.3115L2.8662 15.2949A4.9884 4.9884 0 002 18.1074V26a1 1 0 001 1H5.1421a3.9806 3.9806 0 007.7158 0h6.2842a3.9806 3.9806 0 007.7158 0H29a1 1 0 001-1V18.875A1 1 0 0029.3379 17.9336zM9 28a2 2 0 112-2A2.0027 2.0027 0 019 28zm14 0a2 2 0 112-2A2.0025 2.0025 0 0123 28zm5-3H26.8579a3.9806 3.9806 0 00-7.7158 0H12.8579a3.9806 3.9806 0 00-7.7158 0H4V18.1074A2.9977 2.9977 0 014.52 16.4189l2.711-3.9814A.9992.9992 0 018.0576 12h7.9961a.9928.9928 0 01.7647.3545l3.3994 4.2685a1.0007 1.0007 0 00.4443.3184L28 19.5781zM24.5547 6a2 2 0 012-2H30a3.9756 3.9756 0 00-7.304 1H16V7h6.696A3.9756 3.9756 0 0030 8H26.5547A2 2 0 0124.5547 6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VehicleServices.propTypes = iconPropTypes;
}
const Version = /*#__PURE__*/React.forwardRef(function Version(_ref81, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref81;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2V4H26V19h2V4a2.0023,2.0023,0,0,0-2-2Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M11,7V9H21V24h2V9a2.0023,2.0023,0,0,0-2-2Z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M6,12H16a2.0023,2.0023,0,0,1,2,2V28a2.0023,2.0023,0,0,1-2,2H6a2.0023,2.0023,0,0,1-2-2V14A2.0023,2.0023,0,0,1,6,12Zm10,2L6,13.9988V28H16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Version.propTypes = iconPropTypes;
}
const VersionMajor = /*#__PURE__*/React.forwardRef(function VersionMajor(_ref82, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref82;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5859 17.4141L16 14.8345 16 14.8345 13.4125 17.4156 12 16 16 12 20 16 18.5859 17.4141zM18.5859 11.4141L16 8.8345 16 8.8345 13.4125 11.4156 12 10 16 6 20 10 18.5859 11.4141zM18.5859 23.4141L16 20.8345 16 20.8345 13.4125 23.4156 12 22 16 18 20 22 18.5859 23.4141z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "m1.5858,17.4142c-.3905-.3905-.5858-.9024-.5858-1.4142s.1953-1.0237.5858-1.4142L14.5858,1.5858c.3905-.3905.9023-.5858,1.4142-.5858s1.0237.1953,1.4142.5858l13,13c.3905.3905.5858.9024.5858,1.4142s-.1953,1.0237-.5858,1.4142l-13,13c-.3905.3905-.9024.5858-1.4142.5858s-1.0237-.1953-1.4142-.5858L1.5858,17.4142ZM16,3L3,16l13,13,13-13L16,3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VersionMajor.propTypes = iconPropTypes;
}
const VersionMinor = /*#__PURE__*/React.forwardRef(function VersionMinor(_ref83, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref83;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5859 15.4141L16 12.8345 16 12.8345 13.4125 15.4156 12 14 16 10 20 14 18.5859 15.4141zM18.5859 21.4141L16 18.8345 16 18.8345 13.4125 21.4156 12 20 16 16 20 20 18.5859 21.4141z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "m1.5858,17.4142c-.3905-.3905-.5858-.9024-.5858-1.4142s.1953-1.0237.5858-1.4142L14.5858,1.5858c.3905-.3905.9023-.5858,1.4142-.5858s1.0237.1953,1.4142.5858l13,13c.3905.3905.5858.9024.5858,1.4142s-.1953,1.0237-.5858,1.4142l-13,13c-.3905.3905-.9024.5858-1.4142.5858s-1.0237-.1953-1.4142-.5858L1.5858,17.4142ZM16,3L3,16l13,13,13-13L16,3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VersionMinor.propTypes = iconPropTypes;
}
const VersionPatch = /*#__PURE__*/React.forwardRef(function VersionPatch(_ref84, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref84;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5859 18.4141L16 15.8345 16 15.8345 13.4125 18.4156 12 17 16 13 20 17 18.5859 18.4141z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "m1.5858,17.4142c-.3905-.3905-.5858-.9024-.5858-1.4142s.1953-1.0237.5858-1.4142L14.5858,1.5858c.3905-.3905.9023-.5858,1.4142-.5858s1.0237.1953,1.4142.5858l13,13c.3905.3905.5858.9024.5858,1.4142s-.1953,1.0237-.5858,1.4142l-13,13c-.3905.3905-.9024.5858-1.4142.5858s-1.0237-.1953-1.4142-.5858L1.5858,17.4142ZM16,3L3,16l13,13,13-13L16,3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VersionPatch.propTypes = iconPropTypes;
}
const VerticalView = /*#__PURE__*/React.forwardRef(function VerticalView(_ref85, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref85;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M12 30H4a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 014 2h8a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0112 30zM4 4V28h8V4zM28 30H20a2.0021 2.0021 0 01-2-2V4a2.0021 2.0021 0 012-2h8a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30zM20 4V28h8V4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VerticalView.propTypes = iconPropTypes;
}
const Video = /*#__PURE__*/React.forwardRef(function Video(_ref86, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref86;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M21,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H21a2,2,0,0,1,2,2v4.06l5.42-3.87A1,1,0,0,1,30,9V23a1,1,0,0,1-1.58.81L23,19.94V24A2,2,0,0,1,21,26ZM4,8V24H21V18a1,1,0,0,1,1.58-.81L28,21.06V10.94l-5.42,3.87A1,1,0,0,1,21,14V8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Video.propTypes = iconPropTypes;
}
const VideoAdd = /*#__PURE__*/React.forwardRef(function VideoAdd(_ref87, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref87;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M18 15L14 15 14 11 12 11 12 15 8 15 8 17 12 17 12 21 14 21 14 17 18 17 18 15z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M21,26H4a2.0023,2.0023,0,0,1-2-2V8A2.0023,2.0023,0,0,1,4,6H21a2.0023,2.0023,0,0,1,2,2v4.0566l5.4189-3.87A.9995.9995,0,0,1,30,9V23a.9995.9995,0,0,1-1.5811.8135L23,19.9434V24A2.0023,2.0023,0,0,1,21,26ZM4,8V24.001L21,24V18a.9995.9995,0,0,1,1.5811-.8135L28,21.0566V10.9434l-5.4189,3.87A.9995.9995,0,0,1,21,14V8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VideoAdd.propTypes = iconPropTypes;
}
const VideoChat = /*#__PURE__*/React.forwardRef(function VideoChat(_ref88, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref88;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12H17V14H8zM8 17H13V19H8z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M21,26H4a2.0023,2.0023,0,0,1-2-2V8A2.0023,2.0023,0,0,1,4,6H21a2.0023,2.0023,0,0,1,2,2v4.0566l5.4189-3.87A.9995.9995,0,0,1,30,9V23a.9995.9995,0,0,1-1.5811.8135L23,19.9434V24A2.0023,2.0023,0,0,1,21,26ZM4,8V24.001L21,24V18a.9995.9995,0,0,1,1.5811-.8135L28,21.0566V10.9434l-5.4189,3.87A.9995.9995,0,0,1,21,14V8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VideoChat.propTypes = iconPropTypes;
}
const VideoFilled = /*#__PURE__*/React.forwardRef(function VideoFilled(_ref89, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref89;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M21,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H21a2,2,0,0,1,2,2v4.06l5.42-3.87A1,1,0,0,1,30,9V23a1,1,0,0,1-1.58.81L23,19.94V24A2,2,0,0,1,21,26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VideoFilled.propTypes = iconPropTypes;
}
const VideoOff = /*#__PURE__*/React.forwardRef(function VideoOff(_ref90, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref90;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M29.46 8.11a1 1 0 00-1 .08L23 12.06V10.44l7-7L28.56 2 2 28.56 3.44 30l4-4H21a2 2 0 002-2V19.94l5.42 3.87A1 1 0 0030 23V9A1 1 0 0029.46 8.11zM28 21.06l-5.42-3.87A1 1 0 0021 18v6H9.44L21 12.44V14a1 1 0 001.58.81L28 10.94zM4 24V8H20V6H4A2 2 0 002 8V24z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VideoOff.propTypes = iconPropTypes;
}
const VideoOffFilled = /*#__PURE__*/React.forwardRef(function VideoOffFilled(_ref91, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref91;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M20.31 6H4A2 2 0 002 8V24a2.85 2.85 0 000 .29zM29.46 8.11a1 1 0 00-1 .08L23 12.06V10.44l7-7L28.56 2 2 28.56 3.44 30l4-4H21a2 2 0 002-2V19.94l5.42 3.87A1 1 0 0030 23V9A1 1 0 0029.46 8.11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VideoOffFilled.propTypes = iconPropTypes;
}
const VideoPlayer = /*#__PURE__*/React.forwardRef(function VideoPlayer(_ref92, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref92;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11L13 21 21 16 13 11z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "m28,6H4c-1.103,0-2,.8975-2,2v16c0,1.1025.897,2,2,2h24c1.103,0,2-.8975,2-2V8c0-1.1025-.897-2-2-2Zm0,18H4V8h24v16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VideoPlayer.propTypes = iconPropTypes;
}
const View = /*#__PURE__*/React.forwardRef(function View(_ref93, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref93;
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
      d: "M15.5,7.8C14.3,4.7,11.3,2.6,8,2.5C4.7,2.6,1.7,4.7,0.5,7.8c0,0.1,0,0.2,0,0.3c1.2,3.1,4.1,5.2,7.5,5.3 c3.3-0.1,6.3-2.2,7.5-5.3C15.5,8.1,15.5,7.9,15.5,7.8z M8,12.5c-2.7,0-5.4-2-6.5-4.5c1-2.5,3.8-4.5,6.5-4.5s5.4,2,6.5,4.5 C13.4,10.5,10.6,12.5,8,12.5z"
    })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
      d: "M8,5C6.3,5,5,6.3,5,8s1.3,3,3,3s3-1.3,3-3S9.7,5,8,5z M8,10c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S9.1,10,8,10z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M30.94,15.66A16.69,16.69,0,0,0,16,5,16.69,16.69,0,0,0,1.06,15.66a1,1,0,0,0,0,.68A16.69,16.69,0,0,0,16,27,16.69,16.69,0,0,0,30.94,16.34,1,1,0,0,0,30.94,15.66ZM16,25c-5.3,0-10.9-3.93-12.93-9C5.1,10.93,10.7,7,16,7s10.9,3.93,12.93,9C26.9,21.07,21.3,25,16,25Z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M16,10a6,6,0,1,0,6,6A6,6,0,0,0,16,10Zm0,10a4,4,0,1,1,4-4A4,4,0,0,1,16,20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  View.propTypes = iconPropTypes;
}
const ViewFilled = /*#__PURE__*/React.forwardRef(function ViewFilled(_ref94, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref94;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "4"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M30.94,15.66A16.69,16.69,0,0,0,16,5,16.69,16.69,0,0,0,1.06,15.66a1,1,0,0,0,0,.68A16.69,16.69,0,0,0,16,27,16.69,16.69,0,0,0,30.94,16.34,1,1,0,0,0,30.94,15.66ZM16,22.5A6.5,6.5,0,1,1,22.5,16,6.51,6.51,0,0,1,16,22.5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ViewFilled.propTypes = iconPropTypes;
}
const ViewMode_1 = /*#__PURE__*/React.forwardRef(function ViewMode_1(_ref95, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref95;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M4 26H28V28H4zM4 19H28V21H4zM26 6v6H6V6H26m0-2H6A2 2 0 004 6v6a2 2 0 002 2H26a2 2 0 002-2V6a2 2 0 00-2-2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ViewMode_1.propTypes = iconPropTypes;
}
const ViewMode_2 = /*#__PURE__*/React.forwardRef(function ViewMode_2(_ref96, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref96;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M4 26H28V28H4zM4 19H28V21H4zM12 6v6H6V6h6m0-2H6A2 2 0 004 6v6a2 2 0 002 2h6a2 2 0 002-2V6a2 2 0 00-2-2zM26 6v6H20V6h6m0-2H20a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V6a2 2 0 00-2-2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ViewMode_2.propTypes = iconPropTypes;
}
const ViewOff = /*#__PURE__*/React.forwardRef(function ViewOff(_ref97, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref97;
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
      d: "M2.6,11.3l0.7-0.7C2.6,9.8,1.9,9,1.5,8c1-2.5,3.8-4.5,6.5-4.5c0.7,0,1.4,0.1,2,0.4l0.8-0.8C9.9,2.7,9,2.5,8,2.5 C4.7,2.6,1.7,4.7,0.5,7.8c0,0.1,0,0.2,0,0.3C1,9.3,1.7,10.4,2.6,11.3z"
    })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
      d: "M6 7.9c.1-1 .9-1.8 1.8-1.8l.9-.9C7.2 4.7 5.5 5.6 5.1 7.2 5 7.7 5 8.3 5.1 8.8L6 7.9zM15.5 7.8c-.6-1.5-1.6-2.8-2.9-3.7L15 1.7 14.3 1 1 14.3 1.7 15l2.6-2.6c1.1.7 2.4 1 3.7 1.1 3.3-.1 6.3-2.2 7.5-5.3C15.5 8.1 15.5 7.9 15.5 7.8zM10 8c0 1.1-.9 2-2 2-.3 0-.7-.1-1-.3L9.7 7C9.9 7.3 10 7.6 10 8zM8 12.5c-1 0-2.1-.3-3-.8l1.3-1.3c1.4.9 3.2.6 4.2-.8.7-1 .7-2.4 0-3.4l1.4-1.4c1.1.8 2 1.9 2.6 3.2C13.4 10.5 10.6 12.5 8 12.5z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24,22.51l1.43-1.42A14.06,14.06,0,0,1,3.07,16C5.1,10.93,10.7,7,16,7a12.38,12.38,0,0,1,4,.72l1.55-1.56A14.72,14.72,0,0,0,16,5,16.69,16.69,0,0,0,1.06,15.66a1,1,0,0,0,0,.68A16,16,0,0,0,5.24,22.51Z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.73a4 4 0 013.7-3.7l1.81-1.82a6 6 0 00-7.33 7.33zM30.94 15.66A16.4 16.4 0 0025.2 8.22L30 3.41 28.59 2 2 28.59 3.41 30l5.1-5.1A15.29 15.29 0 0016 27 16.69 16.69 0 0030.94 16.34 1 1 0 0030.94 15.66zM20 16a4 4 0 01-6 3.44L19.44 14A4 4 0 0120 16zm-4 9a13.05 13.05 0 01-6-1.58l2.54-2.54a6 6 0 008.35-8.35l2.87-2.87A14.54 14.54 0 0128.93 16C26.9 21.07 21.3 25 16 25z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ViewOff.propTypes = iconPropTypes;
}
const ViewOffFilled = /*#__PURE__*/React.forwardRef(function ViewOffFilled(_ref98, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref98;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M30.94 15.66a16.4 16.4 0 00-5.73-7.45L30 3.41 28.59 2 2 28.59 3.41 30l5.1-5.09A15.38 15.38 0 0016 27 16.69 16.69 0 0030.94 16.34 1 1 0 0030.94 15.66zM16 22.5a6.46 6.46 0 01-3.83-1.26L14 19.43A4 4 0 0019.43 14l1.81-1.81A6.49 6.49 0 0116 22.5zM4.53 21.81l5-5A6.84 6.84 0 019.5 16 6.51 6.51 0 0116 9.5a6.84 6.84 0 01.79.05l3.78-3.77A14.39 14.39 0 0016 5 16.69 16.69 0 001.06 15.66a1 1 0 000 .68A15.86 15.86 0 004.53 21.81z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ViewOffFilled.propTypes = iconPropTypes;
}
const ViewNext = /*#__PURE__*/React.forwardRef(function ViewNext(_ref99, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref99;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M20.587 22L15 16.41 15 7 16.998 7 16.998 15.582 22 20.587 20.587 22z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A13.9158,13.9158,0,0,1,26,6.2343V2h2v8H20V8h4.9217A11.9818,11.9818,0,1,0,28,16h2A14,14,0,1,1,16,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ViewNext.propTypes = iconPropTypes;
}
const VirtualColumn = /*#__PURE__*/React.forwardRef(function VirtualColumn(_ref100, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref100;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M25 11L26.414 12.414 23.828 15 30 15 30 17 23.828 17 26.414 19.586 25 21 20 16 25 11z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M30 28H20a2.0023 2.0023 0 01-2-2V6a2.0023 2.0023 0 012-2H30V6H20V26H30zM12 28H2V26H12V6H2V4H12a2.0023 2.0023 0 012 2V26A2.0023 2.0023 0 0112 28z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11L5.586 12.414 8.172 15 2 15 2 17 8.172 17 5.586 19.586 7 21 12 16 7 11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VirtualColumn.propTypes = iconPropTypes;
}
const VirtualColumnKey = /*#__PURE__*/React.forwardRef(function VirtualColumnKey(_ref101, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref101;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "24.5",
    cy: "9.5",
    r: "1.5"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4143,22H12V16.5857l6.03-6.03A5.3518,5.3518,0,0,1,18,10a6,6,0,1,1,6,6,5.3583,5.3583,0,0,1-.5559-.03ZM14,20h2.5857l6.1706-6.1709.5174.0957A3.935,3.935,0,0,0,24,14a4.0507,4.0507,0,1,0-3.925-3.2729l.0952.5166L14,17.4143Z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M28,18v8H10V6h4V4H4A2.0025,2.0025,0,0,0,2,6V26a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V18ZM4,6H8V26H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VirtualColumnKey.propTypes = iconPropTypes;
}
const VirtualDesktop = /*#__PURE__*/React.forwardRef(function VirtualDesktop(_ref102, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref102;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M21,16H11a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2h4v2H12v2h8V28H17V26h4a2.0023,2.0023,0,0,0,2-2V18A2.0023,2.0023,0,0,0,21,16ZM11,24V18H21l.0015,6Z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8218,10.124a9.9992,9.9992,0,0,0-19.6436,0A7.4914,7.4914,0,0,0,7,24.9746v-2a5.4945,5.4945,0,0,1,.123-10.9541l.8365-.0566.09-.834a7.9979,7.9979,0,0,1,15.9014,0l.09.834.8365.0566A5.4945,5.4945,0,0,1,25,22.9746v2a7.4914,7.4914,0,0,0,.8218-14.8506Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VirtualDesktop.propTypes = iconPropTypes;
}
const VirtualMachine = /*#__PURE__*/React.forwardRef(function VirtualMachine(_ref103, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref103;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M20,13H12a2.0025,2.0025,0,0,0-2,2V28a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V15A2.0025,2.0025,0,0,0,20,13Zm0,2,0,3H12V15Zm0,5,0,3H12V20Zm-8,8V25h8v3Z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M25.91,10.13a.121.121,0,0,1-.0967-.0952A10.0061,10.0061,0,0,0,17.89,2.1816,10.0025,10.0025,0,0,0,6.1858,10.0347a.1212.1212,0,0,1-.0964.0957A7.5019,7.5019,0,0,0,7.4912,25H8V23H7.4954a5.5108,5.5108,0,0,1-5.4387-6.3,5.6992,5.6992,0,0,1,4.7138-4.6606l1.0166-.1836a.1306.1306,0,0,0,.1045-.1035l.18-.9351a8.28,8.28,0,0,1,6.8469-6.7427,7.957,7.957,0,0,1,2.8471.1245,8.22,8.22,0,0,1,6.1475,6.545l.1941,1.0083a.13.13,0,0,0,.1045.1035l1.0576.1914a5.7819,5.7819,0,0,1,3.1011,1.539A5.5052,5.5052,0,0,1,24.5076,23H24v2h.5076A7.5019,7.5019,0,0,0,25.91,10.13Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VirtualMachine.propTypes = iconPropTypes;
}
const VirtualPrivateCloud = /*#__PURE__*/React.forwardRef(function VirtualPrivateCloud(_ref104, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref104;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M20,20V17a4,4,0,0,0-8,0v3a2.0025,2.0025,0,0,0-2,2v6a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V22A2.0025,2.0025,0,0,0,20,20Zm-6-3a2,2,0,0,1,4,0v3H14ZM12,28V22h8l.0012,6Z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8288,10.1152A10.0067,10.0067,0,0,0,17.89,2.1816,10.0025,10.0025,0,0,0,6.17,10.1152,7.502,7.502,0,0,0,7.4912,25H8V23H7.4953a5.5019,5.5019,0,0,1-.9694-10.9165l1.3488-.2441.2591-1.3457a8.0109,8.0109,0,0,1,15.7312,0l.259,1.3457,1.3489.2441A5.5019,5.5019,0,0,1,24.5076,23H24v2h.5076a7.502,7.502,0,0,0,1.3212-14.8848Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VirtualPrivateCloud.propTypes = iconPropTypes;
}
const VirtualPrivateCloudAlt = /*#__PURE__*/React.forwardRef(function VirtualPrivateCloudAlt(_ref105, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref105;
  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation["VirtualPrivateCloudAlt"]) {
      didWarnAboutDeprecation["VirtualPrivateCloudAlt"] = true;
      console.warn("Icon name was requested by the product team to be renamed to and replaced by ibm-cloud--vpc. As a result, the VirtualPrivateCloudAlt component will be removed in the next major version of @carbon/icons-react.");
    }
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4141,22,10,8.5859V2H2v8H8.5859L22,23.4141V30h8V22ZM8,8H4V4H8ZM28,28H24V24h4Z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M30 6a3.9915 3.9915 0 00-7.8579-1H13V7h9.1421A3.9945 3.9945 0 0025 9.8579V19h2V9.8579A3.9962 3.9962 0 0030 6zM26 8a2 2 0 112-2A2.0023 2.0023 0 0126 8zM19 25H9.8579A3.9945 3.9945 0 007 22.1421V13H5v9.1421A3.9915 3.9915 0 109.8579 27H19zM6 28a2 2 0 112-2A2.0023 2.0023 0 016 28z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VirtualPrivateCloudAlt.propTypes = iconPropTypes;
}
const VisualRecognition = /*#__PURE__*/React.forwardRef(function VisualRecognition(_ref106, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref106;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "12",
    r: "2"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M28,5H16.24A8,8,0,1,0,6,16.92V27a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V7A2,2,0,0,0,28,5ZM4,10A6,6,0,0,1,15.19,7H8V9h7.91A6.64,6.64,0,0,1,16,10a6.64,6.64,0,0,1-.09,1H10v2h5.19A6,6,0,0,1,4,10ZM28,27H8l5-5,1.59,1.59a2,2,0,0,0,2.82,0L23,18l5,5Zm0-6.83-3.59-3.59a2,2,0,0,0-2.82,0L16,22.17l-1.59-1.59a2,2,0,0,0-2.82,0L8,24.17V17.74A8.24,8.24,0,0,0,10,18a8,8,0,0,0,8-8,7.9,7.9,0,0,0-.59-3H28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VisualRecognition.propTypes = iconPropTypes;
}
const Vlan = /*#__PURE__*/React.forwardRef(function Vlan(_ref107, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref107;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M30,17V15H17V11h2a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H13a2.0023,2.0023,0,0,0-2,2V9a2.0023,2.0023,0,0,0,2,2h2v4H2v2H8v4H6a2.0023,2.0023,0,0,0-2,2v5a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V23a2.0023,2.0023,0,0,0-2-2H10V17H22v4H20a2.0023,2.0023,0,0,0-2,2v5a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V23a2.0023,2.0023,0,0,0-2-2H24V17ZM13,4h6V9H13ZM12,28H6V23h6Zm14,0H20V23h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Vlan.propTypes = iconPropTypes;
}
const VlanIbm = /*#__PURE__*/React.forwardRef(function VlanIbm(_ref108, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref108;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M16 22a4 4 0 104 4A4.0045 4.0045 0 0016 22zm0 6a2 2 0 112-2A2.002 2.002 0 0116 28zM30 5a3 3 0 10-4 2.8154V15H17V9H15v6H6V7.8159a3.0007 3.0007 0 10-2 0V15a2.002 2.002 0 002 2h9v3h2V17h9a2.002 2.002 0 002-2V7.8159A2.9958 2.9958 0 0030 5zM5 4A1 1 0 114 5 1.0013 1.0013 0 015 4zM27 6a1 1 0 111-1A1.0013 1.0013 0 0127 6z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "5",
    r: "2"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VlanIbm.propTypes = iconPropTypes;
}
const VmdkDisk = /*#__PURE__*/React.forwardRef(function VmdkDisk(_ref109, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref109;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "10.5",
    cy: "24.5",
    r: "1.5"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 14.964H21.5V20.035H19.5z",
    transform: "rotate(-45 20.5 17.5)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "13",
    r: "2"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M16,6a7,7,0,0,0,0,14V18a5,5,0,1,1,5-5h2A7,7,0,0,0,16,6Z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M26,2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4A2,2,0,0,0,26,2Zm0,26H6V4H26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VmdkDisk.propTypes = iconPropTypes;
}
const VoiceActivate = /*#__PURE__*/React.forwardRef(function VoiceActivate(_ref110, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref110;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H24V27H20a5.0055,5.0055,0,0,1-5-5V20.7207l-2.3162-.772a1,1,0,0,1-.5412-1.4631L15,13.7229V11a9.01,9.01,0,0,1,9-9h5V4H24a7.0078,7.0078,0,0,0-7,7v3a.9991.9991,0,0,1-.1426.5144l-2.3586,3.9312,1.8174.6057A1,1,0,0,1,17,20v2a3.0033,3.0033,0,0,0,3,3h5a1,1,0,0,1,1,1Z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M19 12H23V14H19zM9.3325 25.2168a7.0007 7.0007 0 010-10.4341l1.334 1.49a5 5 0 000 7.4537z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3994,28.8008a11.0019,11.0019,0,0,1,0-17.6006L7.6,12.8a9.0009,9.0009,0,0,0,0,14.4014Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VoiceActivate.propTypes = iconPropTypes;
}
const Voicemail = /*#__PURE__*/React.forwardRef(function Voicemail(_ref111, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref111;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M24,10a6,6,0,0,0-4.46,10H12.46A6,6,0,1,0,8,22H24a6,6,0,0,0,0-12ZM4,16a4,4,0,1,1,4,4A4,4,0,0,1,4,16Zm20,4a4,4,0,1,1,4-4A4,4,0,0,1,24,20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Voicemail.propTypes = iconPropTypes;
}
const VolumeBlockStorage = /*#__PURE__*/React.forwardRef(function VolumeBlockStorage(_ref112, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref112;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M17 21H10V14h7zm-5-2h3V16H12zM17 30H10V23h7zm-5-2h3V25H12zM26 21H19V14h7zm-5-2h3V16H21zM26 30H19V23h7zm-5-2h3V25H21z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M8,28H4a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,4,4h7.5857A1.9865,1.9865,0,0,1,13,4.5859L16.4143,8H28a2.0023,2.0023,0,0,1,2,2v8H28V10H15.5857l-4-4H4V26H8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VolumeBlockStorage.propTypes = iconPropTypes;
}
const VolumeDown = /*#__PURE__*/React.forwardRef(function VolumeDown(_ref113, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref113;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1 10.66L23.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM20 30a1 1 0 01-.71-.3L11.67 22H5a1 1 0 01-1-1H4V11a1 1 0 011-1h6.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0121 3V29A1 1 0 0120 30zM6 20h6a1.17 1.17 0 01.79.3L19 26.57V5.43L12.79 11.7A1.17 1.17 0 0112 12H6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VolumeDown.propTypes = iconPropTypes;
}
const VolumeDownAlt = /*#__PURE__*/React.forwardRef(function VolumeDownAlt(_ref114, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref114;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M22 15H32V17H22zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30zM4 20h6a1.2008 1.2008 0 01.7939.2969L17 26.5684V5.4316l-6.2061 6.2715A1.2013 1.2013 0 0110 12H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VolumeDownAlt.propTypes = iconPropTypes;
}
const VolumeDownFilled = /*#__PURE__*/React.forwardRef(function VolumeDownFilled(_ref115, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref115;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1 10.66L23.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM20 30a1 1 0 01-.71-.3L11.67 22H5a1 1 0 01-1-1H4V11a1 1 0 011-1h6.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0121 3V29A1 1 0 0120 30z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VolumeDownFilled.propTypes = iconPropTypes;
}
const VolumeDownFilledAlt = /*#__PURE__*/React.forwardRef(function VolumeDownFilledAlt(_ref116, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref116;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M22 15H32V17H22zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VolumeDownFilledAlt.propTypes = iconPropTypes;
}
const VolumeFileStorage = /*#__PURE__*/React.forwardRef(function VolumeFileStorage(_ref117, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref117;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M25.707,17.293l-5-5A1,1,0,0,0,20,12H14a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V18A1,1,0,0,0,25.707,17.293ZM23.5857,18H20V14.4141ZM14,28V14h4v4a2,2,0,0,0,2,2h4v8Z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M8,27H4a2.0023,2.0023,0,0,1-2-2V5A2.0023,2.0023,0,0,1,4,3h7.5857A1.9865,1.9865,0,0,1,13,3.5859L16.4143,7H28a2.0023,2.0023,0,0,1,2,2v8H28V9H15.5857l-4-4H4V25H8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VolumeFileStorage.propTypes = iconPropTypes;
}
const VolumeMute = /*#__PURE__*/React.forwardRef(function VolumeMute(_ref118, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref118;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M31 12.41L29.59 11 26 14.59 22.41 11 21 12.41 24.59 16 21 19.59 22.41 21 26 17.41 29.59 21 31 19.59 27.41 16 31 12.41zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30zM4 20h6a1.17 1.17 0 01.79.3L17 26.57V5.43L10.79 11.7A1.17 1.17 0 0110 12H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VolumeMute.propTypes = iconPropTypes;
}
const VolumeMuteFilled = /*#__PURE__*/React.forwardRef(function VolumeMuteFilled(_ref119, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref119;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M31 12.41L29.59 11 26 14.59 22.41 11 21 12.41 24.59 16 21 19.59 22.41 21 26 17.41 29.59 21 31 19.59 27.41 16 31 12.41zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VolumeMuteFilled.propTypes = iconPropTypes;
}
const VolumeObjectStorage = /*#__PURE__*/React.forwardRef(function VolumeObjectStorage(_ref120, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref120;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M23,24a2.98,2.98,0,0,0-2.0376.8115l-4.0037-2.4023a2.0478,2.0478,0,0,0,0-.8184l4.0037-2.4023a3.2463,3.2463,0,1,0-.9211-1.7793l-4.0037,2.4023a3,3,0,1,0,0,4.377l4.0037,2.4023A2.9729,2.9729,0,0,0,20,27a3,3,0,1,0,3-3Zm0-8a1,1,0,1,1-1,1A1.0008,1.0008,0,0,1,23,16Zm-9,7a1,1,0,1,1,1-1A1.0008,1.0008,0,0,1,14,23Zm9,5a1,1,0,1,1,1-1A1.0008,1.0008,0,0,1,23,28Z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M8,28H4a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,4,4h7.5857A1.9865,1.9865,0,0,1,13,4.5859L16.4143,8H28a2.0023,2.0023,0,0,1,2,2v8H28V10H15.5857l-4-4H4V26H8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VolumeObjectStorage.propTypes = iconPropTypes;
}
const VolumeUp = /*#__PURE__*/React.forwardRef(function VolumeUp(_ref121, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref121;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M27.16,8.08,25.63,9.37a10,10,0,0,1-.29,13.23L26.81,24a12,12,0,0,0,.35-15.88Z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M21.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30zM4 20h6.08a1 1 0 01.71.3L17 26.57V5.43L10.79 11.7a1 1 0 01-.71.3H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VolumeUp.propTypes = iconPropTypes;
}
const VolumeUpAlt = /*#__PURE__*/React.forwardRef(function VolumeUpAlt(_ref122, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref122;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M32 15L28 15 28 11 26 11 26 15 22 15 22 17 26 17 26 21 28 21 28 17 32 17 32 15zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30zM4 20h6a1.2008 1.2008 0 01.7939.2969L17 26.5684V5.4316l-6.2061 6.2715A1.2013 1.2013 0 0110 12H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VolumeUpAlt.propTypes = iconPropTypes;
}
const VolumeUpFilled = /*#__PURE__*/React.forwardRef(function VolumeUpFilled(_ref123, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref123;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M27.16,8.08,25.63,9.37a10,10,0,0,1-.29,13.23L26.81,24a12,12,0,0,0,.35-15.88Z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M21.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VolumeUpFilled.propTypes = iconPropTypes;
}
const VolumeUpFilledAlt = /*#__PURE__*/React.forwardRef(function VolumeUpFilledAlt(_ref124, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref124;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M32 15L28 15 28 11 26 11 26 15 22 15 22 17 26 17 26 21 28 21 28 17 32 17 32 15zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  VolumeUpFilledAlt.propTypes = iconPropTypes;
}
const Vpn = /*#__PURE__*/React.forwardRef(function Vpn(_ref125, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref125;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM28 19L24.32 9 22 9 22 23 24 23 24 13 27.68 23 30 23 30 9 28 9 28 19zM8 9L6 22 4 9 2 9 4.52 23 7.48 23 10 9 8 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Vpn.propTypes = iconPropTypes;
}

export { QU1, QU2, QU3, TrashCan, Tree, TreeFallRisk, TreeView, TreeViewAlt, Trophy, TrophyFilled, TropicalStorm, TropicalStormModelTracks, TropicalStormTracks, TropicalWarning, Tsq, Tsunami, Tsv, Tuning, TwoFactorAuthentication, TwoPersonLift, Txt, TxtReference, TypePattern, Types, Umbrella, Undefined, UndefinedFilled, Undo, UngroupObjects, Unknown, UnknownFilled, Unlink, Unlocked, Unsaved, UpToTop, UpdateNow, Upgrade, Upload, Upstream, Url, Usb, User, UserAccess, UserActivity, UserAdmin, UserAvatar, UserAvatarFilled, UserAvatarFilledAlt, UserCertification, UserData, UserFavorite, UserFavoriteAlt, UserFavoriteAltFilled, UserFilled, UserFollow, UserIdentification, UserMilitary, UserMultiple, UserOnline, UserProfile, UserProfileAlt, UserRole, UserServiceDesk, UserSettings, UserSimulation, UserSpeaker, UserSponsor, UserXRay, UvIndex, UvIndexAlt, UvIndexFilled, ValueVariable, Van, VegetationAsset, VegetationEncroachment, VegetationHeight, VehicleApi, VehicleConnected, VehicleInsights, VehicleServices, Version, VersionMajor, VersionMinor, VersionPatch, VerticalView, Video, VideoAdd, VideoChat, VideoFilled, VideoOff, VideoOffFilled, VideoPlayer, View, ViewFilled, ViewMode_1, ViewMode_2, ViewNext, ViewOff, ViewOffFilled, VirtualColumn, VirtualColumnKey, VirtualDesktop, VirtualMachine, VirtualPrivateCloud, VirtualPrivateCloudAlt, VisualRecognition, Vlan, VlanIbm, VmdkDisk, VoiceActivate, Voicemail, VolumeBlockStorage, VolumeDown, VolumeDownAlt, VolumeDownFilled, VolumeDownFilledAlt, VolumeFileStorage, VolumeMute, VolumeMuteFilled, VolumeObjectStorage, VolumeUp, VolumeUpAlt, VolumeUpFilled, VolumeUpFilledAlt, Vpn };
